import { useMemo } from "react";

import { useAuthUserQuery } from "modules/user/hooks/queries/useAuthUserQuery";

import { getSubdomain } from "../utils/helpers";

export const useActiveAccount = () => {
  const { data: userData } = useAuthUserQuery();

  const activeAccount = useMemo(() => {
    if (!userData) return null;

    const subdomain = getSubdomain();

    const account = userData.accounts.find(acc => acc.subdomain === subdomain);

    return account || null;
  }, [userData]);

  return { activeAccount };
};
